import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConnectorTag, IDiscrepancyPurgeableResponse } from '@bciti/types';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';

@Injectable({
    providedIn: 'root',
})
export class DiscrepancyService {
    constructor(private http: HttpClient, private store: Store<State>) {}

    getSystExtWithPurgeableData(organisation: string): Observable<IDiscrepancyPurgeableResponse[]> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.get<any>(`${env.baseUrl}/cerberus/discrepancy/${organisation}/purgeable`)));
    }

    purgeData(organisation: string, connectorTag: ConnectorTag): Observable<void> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.delete<any>(`${env.baseUrl}/cerberus/discrepancy/${organisation}/${connectorTag}`)));
    }
}
